<template>
  <!-- v-show="showEditor" -->
  <base-modal
    id="product-editor-modal"
    :show="showEditor"
    title="Add Product Row"
    @closed="$emit('closed')"
  >
    <template #default>
      <image-editor
        ref="imageEditor"
        editor-title="Edit Album"
        :initial-step="1"
        :pre-filled-image="`${productImage.image_url}?w=2000&h=2000`"
        :is-loading="loading"
        :is-circle="false"
        :fit-to-mask="true"
        :product-url="productURL"
        :width="productWidth"
        :height="productHeight"
        secondary-action-text="Cancel Image"
        @change-avatar="onSave"
        @delete-avatar="onDelete"
        @cancel-selection="onCancel"
        @close-editor="onCancel"
        @product-url-changed="productURL = $event"
      />
      <div class="product-editor__fields">
        <template v-if="showBrandName">
          <base-text class="product-editor__label">
            Brand
          </base-text>
          <input
            v-model="productBrand"
            type="text"
            class="product-editor__input"
            name="brand"
            placeholder="Add a brand"
            :readonly="loading"
            @keydown.enter="upload"
          >
        </template>
        <base-text class="product-editor__label">
          Description
        </base-text>
        <input
          v-model="productDescription"
          type="text"
          name="description"
          placeholder="Add a description"
          class="product-editor__input"
          :readonly="loading"
          @keydown.enter="upload"
        >
        <base-text class="product-editor__label">
          URL
        </base-text>
        <input
          v-model="productURL"
          type="text"
          name="url"
          placeholder="Add a URL"
          class="product-editor__input"
          :readonly="loading"
          @keydown.enter="upload"
        >
      </div>
    </template>
    <template #footer>
      <base-button
        inverse
        style="padding: 8.5px 16px; font-size: 14px; margin: 0;"
        :disabled="loading"
        @click="upload"
      >
        <span v-if="!loading">
          Save
        </span>
        <span v-else>
          <base-loading :show="true" />
        </span>
      </base-button>
    </template>
  </base-modal>
</template>
<script>
import ImageEditor from '@/components/Widgets/ClientInformation/ImageEditor';
import productImageUtil from '@/_utilities/productImage';
import { EventBus } from '@/event-bus';
import api from '@/_api';

export default {

  name: 'ProductEditor',
  components: {
    ImageEditor,
  },
  props: {
    productImage: {
      type: Object,
      default: () => {},
    },
    showEditor: {
      type: Boolean,
      default: false,
    },
    isCollateral: {
      type: Boolean,
      required: true,
    },
    secondaryActionText: {
      type: String,
      default: 'Change Image',
    },
  },
  data() {
    return {
      productBrand: '',
      productDescription: '',
      productURL: '',
    };
  },
  computed: {
    loading() {
      return this.$store.state.productImage.isLoading;
    },
    productHeight() {
      return this.$store.getters['account/theme'].product_height;
    },
    productWidth() {
      return this.$store.getters['account/theme'].product_width;
    },
    showBrandName() {
      return this.$store.getters['account/theme'].product_display_brand;
    },
  },
  watch: {
    showEditor(value) {
      if (!value) {
        this.reset();
      }
    },
  },
  methods: {
    reset() {
      this.productBrand = '';
      this.productDescription = '';
      this.productURL = '';
    },
    checkAction() {
      if (this.secondaryActionText === 'Change Image') {
        this.$nextTick().then(() => this.$refs.imageEditor.selectImage());
      }
      if (this.secondaryActionText === 'Cancel Image') {
        return this.$emit('cancel-selection');
      }
      return '';
    },
    upload() {
      if (!this.productURL.includes('http') && this.productURL.trim().length > 0) {
        this.productURL = `https://${this.productURL}`;
      }
      this.$nextTick().then(() => {
        this.$refs.imageEditor.upload();
      });
    },
    fillData() {
      if (Object.keys(this.productImage).length === 0 && this.productImage.constructor === Object) {
        return; // If object is empty do nothing
      }
      if (this.productImage.product.brand.name !== null) {
        this.productBrand = this.productImage.product.brand.name;
      }
      if (this.productImage.product.title !== null) {
        this.productDescription = this.productImage.product.title;
      }
      if (this.productImage.product.site_url !== null || this.productImage.site_url !== null) {
        const siteURL = this.productImage.site_url;
        this.productURL = (siteURL || this.productImage.product.site_url);
      }
    },
    onDelete() {
      const product = this.productImage;
      const { isCollateral } = this;
      this.$emit('delete-product', { isCollateral, product });
    },
    onCancel() {
      this.$emit('cancel-edit');
    },
    formatUrl() {
      // If it's not a WhatsApp link, preserve original.
      return this.productURL !== '' && !this.$options.methods.isWsp(this.productURL)
        ? this.productURL
        : '';

      // if (this.productURL !== '' && !this.$options.methods.isWsp(this.productURL)) {
      //   return this.productURL;
      // }
      // const productMessage = `I'm interested in the ${this.productBrand.replaceAll(' ', '%20')} ${this.productDescription.replaceAll(' ', '%20')}`; Previous approach when we knew before hand the product title and brand
      // const productMessage = 'I\'m interested in this product';
      // return `${this.productURL}?text=${productMessage.replaceAll(' ', '%20')}`;
    },
    onSave(imageObject) {
      this.$store.dispatch('productImage/setIsLoading', true);
      api.post('/upload_media_to_s3', {
        url: imageObject.image,
      }).then((response) => {
        const editedProduct = productImageUtil.create({
          ...this.productImage,
          site_url: this.formatUrl(),
          brand: this.productBrand,
          description: this.productDescription,
          image_url: response.data.upload_url,
        });
        editedProduct.content_type = imageObject.file.type;
        const { isCollateral } = this;
        this.$emit('complete', { editedProduct, isCollateral });
      }).catch(() => {
        this.$store.dispatch('productImage/setIsLoading', false);
        EventBus.$emit('toast-error',
          'An error has occurred while trying to update this image, please try again later');
      });
    },
  },
};
</script>
<style lang="scss"
  scoped>
.custom-label {
  color: #aaaaaa;
}

.custom-input {
  border: solid 1px #aaaaaa;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-radius: 5px;
  width: 100%;
  font-family: $font-family-sans-serif-light;
  font-size: 14px;
}

::v-deep .modal-content {
  border-radius: 0;
  .modal-body {
    padding: 0;
  }
  .modal-footer{
    padding: 16px 32px;
  }
}

.product-editor{
  &__fields{
    padding: 10px 32px;
  }
  &__label{
    font-family: $font-family-sans-serif-light;
    font-size: 14px;
    line-height: 16px;
    color: #1B1B1B;
    margin-top: 1.1rem;
    margin-bottom: 6px;
  }
  &__input{
    border: 1px solid #C6C6C6;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    border-radius: 5px;
    width: 100%;
    font-family: $font-family-sans-serif-light;
    font-size: 14px;
    height: 36px;
  }
}
::v-deep .modal-header {
  padding-top: 28px;
  padding-bottom: 32px;
  padding-right: 32px;
  padding-left: 32px;
  border-bottom: unset;
}
::v-deep .modal-header .close{
  padding-right: 0;
  margin-right: 0 !important;
}
::v-deep .header-title{
  font-family: 'Tiempos Headline';
  font-weight: 600;
  font-size: 23px;
  margin: 0 !important;
  height: 28px;
}
::v-deep input::placeholder{
    color: #909090;
}
::v-deep .modal-content{
  border-radius: 4px;
}
</style>
